import React from 'react';
import CookieBanner from 'react-cookie-banner';
import { withNamespaces } from 'react-i18next';

const Cookie = (props) => {
  return (
    <CookieBanner
      message={props.t('common:cookies.text')}
      dismissOnScroll={false}
      cookie="AcceptRobotexCookies"
      disableStyle={true}
      className="rtxCookie"
      closeIcon="close icon"
    />
  );
};

export default withNamespaces('common')(Cookie);



// WEBPACK FOOTER //
// ./src/common/components/Cookie/index.js